import React, { useRef, useEffect, useState, useMemo } from "react";
import { LandingHoverWrapper } from "../styles/components/landing";

const LandingHoverVideo = ({ content, hoveredIndex, planesLength }) => {
  const [MuxVideo, setMuxVideo] = useState(null);
  const videoRefs = useRef({});

  const sectionVideos = useMemo(() => {
    return content.flatMap(section => section.video);
  }, [content]);

  useEffect(() => {
    let isMounted = true;

    const loadMux = async () => {
      const { default: Mux } = await import("@mux/mux-video-react");
      if (isMounted) setMuxVideo(() => Mux);
    };

    loadMux();

    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    if (hoveredIndex >= planesLength - 1) return;

    Object.keys(videoRefs.current).forEach(key => {
      const video = videoRefs.current[key];
      if (!video) return;

      if (parseInt(key) == hoveredIndex) {
        video.play().catch(err => {
          console.error("Safari refused play():", err);
        });
      } else {
        video.pause();
      }
    });

    return () => {
      videoRefs.current = {};
    };
  }, [hoveredIndex]);

  if (!MuxVideo) return null;

  return (
    <LandingHoverWrapper>
      {sectionVideos &&
        Object.entries(sectionVideos).map(([key, muxvideo]) => {
          if (muxvideo && muxvideo.video) {
            return (
              <MuxVideo
                key={key}
                ref={el => (videoRefs.current[key] = el)}
                playbackId={muxvideo.video.muxPlaybackId}
                metadata={{
                  video_id: muxvideo.video.muxPlaybackId,
                  video_title: muxvideo.title || "Hover Video",
                }}
                streamType="on-demand"
                controls={false}
                preload="auto"
                muted
                loop
                autoPlay
                playsInline
                disablePictureInPicture
                disableRemotePlayback
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  opacity: hoveredIndex == key ? 1 : 0,
                  transition: "opacity 0s ease-in-out",
                  pointerEvents: "none",
                }}
              />
            );
          }

          return null;
        })}
    </LandingHoverWrapper>
  );
};

export default React.memo(LandingHoverVideo);
